<template>
    <div class="check_box">
        <div class="add_bank"
             @click="showToast">
            <div class="add_bank_box">
                <div v-if="payType == '0'">
                    <span class="add_bank_btn_zfb"></span>
                </div>
                <div v-if="payType == '1'">
                    <span class="add_bank_btn_wx"></span>
                </div>
            </div>
            <div class="bank_con"
                 v-if="payType == '0'">
                <p class="title">支付宝提现</p>
                <p class="info">提现金额将发送至您的支付宝账户</p>
            </div>
            <div class="bank_con"
                 v-if="payType =='1'">
                <p class="title">微信提现</p>
                <p class="info">提现金额将发送至您的微信零钱</p>
            </div>
            <div class="bank_right">
            </div>
        </div>
        <div class="money_box">
            <p class="bd">
                <span class="dw">￥</span>
                <input type="text"
                       class="money"
                       placeholder="请输入提现金额"
                       @input="toCheck($event)"
                       v-model="applyMoney">
            </p>
            <p class="info">
                <span>可提现余额：{{allMoney}}元</span>
                <span class="info_btn"
                      @click="changeMoney">全部提现</span>
            </p>
            <div v-if="payType == '0'">
                <p class="bd">
                    <input type="text"
                           class="aliPayAccount"
                           placeholder="请输入本人的支付宝账户"
                           v-model="aliPayAccount">
                </p>
            </div>
        </div>
        <div v-if="payType == '1'">
            <div v-if="!wxAuth">
                <div class="wx_content">
                    <p class="wechat"><span @click="auth">绑定微信账户</span></p>
                </div>
            </div>
            <div v-if="wxAuth">
                <div class="wx_content">
                    <img :src="avater">
                    <div class="content">
                        <p class="name">{{nickName}}</p>
                        <p>已绑定</p>
                    </div>
                    <div class="gh" @click="genghuan">更换账户</div>
                </div>
            </div>
        </div>

        <div class="tips_box">
            <p>温馨提示：</p>
            <ul>
                <li>提现金额范围：5-25元</li>
                <li>每天最多提现三次</li>
                <div v-if="payType == '0'">
                    <li>仅提现至本人实名认证的支付宝账户</li>
                </div>
                <div v-if="payType == '1'">
                    <li>仅提现至本人实名认证的微信账户</li>
                </div>
            </ul>
        </div>
        <div class="btn_box">
      <span class="btn" :class="{'opacity':parseFloat(applyMoney) >= 5}"
            @click="toWithDral">提交</span>
        </div>

        <van-popup v-model="followToast" :round="true">
            <div class="followToast">
                <div class="img">
                    <img src="@/assets/img/afterLoan/tcHelp.png" style="width: 100%;height: 100%;">
                </div>
                <div class="title">扫二维码关注公众号</div>
                <div class="desc">关注“同城助手服务中心”，输入APP注册手机号和验证码按提示操作</div>
                <div class="btn" @click="followToast=false"><span>我知道了</span></div>
            </div>
        </van-popup>

    </div>
</template>

<script>
    export default {
        components: {
            // Head,
        },
        data() {
            return {
                isBind: '',
                allMoney: 0,
                applyMoney: 0,
                copyText: '77服务中心',
                money: '',
                isShow: false,
                appVersion: localStorage.getItem('appVersion'),
                showBtn: false,
                applyNum: '',
                aliPayAccount: '',
                wxAuth: false,
                nickName: '',
                avater: '',
                payType: '',
                followToast: false,
            }
        },
        mounted() {
            this.getIsBind();
            this.appVersion = localStorage.getItem('appVersion');
            this.money = this.$route.query.money;//账户余额
            this.util.title('申请提现');
            if (parseFloat(this.appVersion) >= parseFloat('1.1.0')) {
                this.showBtn = true;
            } else {
                this.showBtn = false;
            }
            this.payType = this.$route.query.payType;
        },
        methods: {
            toCheck(e) {
                this.applyMoney = e.target.value.replace(/[^\d.]/g, '')
                if (parseFloat(this.applyMoney) > parseFloat(this.allMoney)) {
                    this.applyMoney = this.allMoney
                }
            },
            showToast() {
                if (this.isBind == '0') {
                    this.isShow = true;
                }
            },
            toHide() {
                this.isShow = false;
            },
            // 复制成功
            onCopy(e) {
                // this.util.toast({ msg: '复制成功' })
                this.toWeChatNum();//前往微信
            },
            // 复制失败
            onError(e) {
                this.util.toast({msg: '复制失败'})
            },
            toWithDral() {
                if(!this.wxAuth){
                    this.util.toast({msg: '请先完成微信绑定'})
                    return false;
                }
                let aliPayAccount = this.aliPayAccount;
                let amount = parseFloat(this.applyMoney);
                if (amount > 25 || amount < 5) {
                    this.util.toast({msg: '提现金额范围:5-25元'})
                    return false;
                } else if (this.applyNum >= 4) {
                    this.util.toast({msg: '每天最多提现三次'})
                    return false;
                }
                let source = 0;
                if (this.payType == 0) {
                    source = 0;
                } else if (this.payType == 1) {
                    source = 1;
                }
                let param = {
                    money: amount,
                    source: source
                }
                if (this.isBind == '0') {
                    this.$post('/app/v1.0/pay/withdraw', param)
                        .then(res => {
                            var e = res;
                            if (e.code == 200) {
                                this.toPage();
                            } else {
                                this.util.toast({msg: e.message})
                            }
                        })
                        .catch(error => {
                        });
                }
            },
            getIsBind() {
                this.$get('/app/v1/account/info', {})
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.isBind = e.data.isBind;
                            this.allMoney = e.data.account;
                            this.applyNum = e.data.applyNum;
                            this.wxAuth = e.data.wxAuth;
                            this.nickName = e.data.nickName;
                            this.avater = e.data.avater;
                        } else {
                            _this.util.toast({msg: e.msg})
                        }
                    })
                    .catch(error => {
                    });
            },
            changeMoney() {
                this.applyMoney = this.allMoney
            },
            toPage() {
                this.$router.push({
                    path: '/vip/withDralSucc',
                    query: {
                        money: this.money,
                        payType: this.payType
                    }
                });
            },
            //调用android和ios的方法——前往公众号
            toWeChatNum() {
                this.isShow = false;
                if (this.isBind == '0') {
                    try {
                        window.webkit.messageHandlers.toWeChatNum.postMessage("");//ios
                    } catch (err) {
                        window.AppJs.toWeChatNum();//android
                    }
                    this.$router.push({
                        path: '/vipActive/myCard',
                        query: {
                            isActive: 2,
                        }
                    });
                }
            },
            auth() {
                if ("com.tcb.TCHelp" == localStorage.getItem("packageName")) {
                    this.followToast = true;
                } else {
                    this.util.toWeChatAuth();
                }
            },
            genghuan() {
                this.wxAuth = false;
            }
        }

    }
</script>
<style scoped>
    .check_box {
        background: #f7f7f7;
    }

    .add_bank {
        display: flex;
        flex: 1;
        justify-content: space-between;
        padding: 0.15rem;
        height: 0.67rem;
        margin-bottom: 0.1rem;
        background: #fff;
    }

    .add_bank_box {
        flex: 0.1;
    }

    .bank_con {
        flex: 0.75;
        position: relative;
        top: -0.02rem;
    }

    .bank_right {
        flex: 0.1;
        text-align: right;
    }

    .add_bank .title {
        font-size: 0.16rem;
        color: #333;
    }

    .add_bank .title1 {
        line-height: 0.42rem;
    }

    .add_bank .info {
        font-size: 0.11rem;
        color: #999;
    }

    .add_bank_btn_zfb {
        display: inline-block;
        width: 0.36rem;
        height: 0.36rem;
        background: url('../../assets/img/vip/zfb_logo.png') no-repeat top center;
        background-size: 100% 100%;
        margin: 0 auto;
    }

    .add_bank_btn_wx {
        display: inline-block;
        width: 0.36rem;
        height: 0.36rem;
        background: url('../../assets/img/vip/wechat_logo.png') no-repeat top center;
        background-size: 100% 100%;
        margin: 0 auto;
    }

    .money_box {
        background: #fff;
        padding: 0.1rem 0.15rem;
    }

    .tips_box {
        color: #999;
        font-size: 0.12rem;
        padding: 0.07rem 0.15rem 0.27rem 0.15rem;
    }

    .tips_box ul {
        padding: 0 0.15rem;
        margin-top: 0.05rem;
    }

    .tips_box li {
        list-style-type: disc;
        margin-bottom: 0.05rem;
    }

    .money_box .dw {
        font-size: 0.34rem;
        color: #333;
        /* position: relative;
        top: 0.03rem; */
    }

    .money_box .money {
        padding: 0 0.1rem;
        color: #333;
        font-size: 0.26rem;
        width: 80%;
        position: relative;
        top: -0.04rem;
        /* height: 0.37rem;
        line-height: 37px; */
    }

    .money_box .aliPayAccount {
        padding: 0.1rem 0.1rem;
        color: #333;
        font-size: 0.15rem;
        width: 100%;
        position: relative;
        top: 0.08rem;
        /* height: 0.37rem;
        line-height: 37px; */
    }

    input::-webkit-input-placeholder {
        color: #d9d9d9;
        font-size: 0.26rem;
        transform: translate(0, 0.04rem);
    }

    .money_box .bd {
        border-bottom: 1px solid #f5f5f5;
        margin-bottom: 0.15rem;
        padding-bottom: 0.06rem;
    }

    .wx_content {
        margin-top: 0.1rem;
        width: 100%;
        height: 74px;
        border: 1px solid #fff;
        background: #FFFFFF;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .wx_content .wechat {
        width: 124px;
        height: 34px;
        background: #00CC33;
        border-radius: 20px;
        border: 1px solid #00C454;
        text-align: center;
        margin: 0.2rem auto;
    }

    .wx_content .wechat span {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 34px;
    }

    .wx_content img {
        width: 42px;
        height: 42px;
        float: left;
        line-height: 74px;
        margin: 0.1rem 0.2rem;
        border-radius: 6px;
    }

    .wx_content .content {
        width: 52%;
        height: 74px;
        float: left;
        line-height: 25px;
    }

    .wx_content .content .name {
        margin-top: 0.1rem;
        font-size: 17px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 700;
        color: #000000;
    }

    .wx_content .gh {
        line-height: 74px;
        margin-right: 0.15rem;
        float: right;
    }

    .btn_box {
        text-align: center;
    }

    .btn {
        display: inline-block;
        color: #ffffff;
        font-size: 0.17rem;
        text-align: center;
        background: linear-gradient(
                90deg,
                rgba(122, 157, 246, 1) 0%,
                rgba(81, 117, 241, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 25px;
        height: 0.5rem;
        line-height: 0.5rem;
        width: 90%;
        margin: 0 auto;
        /*opacity: 0.4;*/
    }

    .info {
        color: #666;
        font-size: 0.14rem;
    }

    .info_btn {
        color: #527af5;
        float: right;
    }

    .toast .title {
        color: #000;
        font-size: 0.16rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
    }

    .toast .info {
        color: #000;
        font-size: 0.16rem;
        line-height: 0.31rem;
    }

    .toast .logo {
        width: 1.91rem;
        height: 1.11rem;
        margin-bottom: 0.25rem;
    }

    .followToast{
        width: 2.65rem;
        background: #FFFFFF;
        border-radius: 0.14rem;
        text-align: center;
        padding: 0.15rem;
    }

    .followToast .img{
        width: 1.8rem;
        height: 1.8rem;
        margin: 0.12rem auto 0rem;
    }

    .followToast .title{
        font-size: 0.18rem;
        font-weight: 500;
        color: #3D3D3D;
        margin: 0.12rem auto;
    }

    .followToast .desc{
        font-size: 0.14rem;
        font-weight: 400;
        color: #3D3D3D;
    }

    .followToast .btn{
        width: 90%;
        height: 0.41rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.21rem;
        text-align: center;
        line-height: 0.41rem;
        margin: 0.2rem auto;
    }

    .followToast .btn span{
        font-size: 0.16rem;
        font-weight: 500;
        color: #FFFFFF;
    }

</style>
